import * as React from 'react';

import * as styles from './index.css';

export interface IOfferAddedProps {
  added: string;
}

export class OfferAdded extends React.Component<IOfferAddedProps, {}> {
  public render() {
    if (!this.props.added) {
      return null;
    }

    return (
      <div className={styles['container']}>
        {this.props.added}
      </div>
    );
  }
}
